<template>
  <div class="work" v-if="$root.dataReady">
    <modal v-if="showModal" @close="showModal = false">
      <div slot="content">
        <div class="videoWrapper">
          <iframe
            :src="videosrc"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </modal>
    <header class="heading">
      <div class="container">
        <div class="text">
          <div v-html="page.content.rendered" />
          <a
            class="btn default white white-play"
            id="show-modal"
            v-if="videosrc"
            @click="showModal = true"
          >
            <svg
              width="13px"
              height="14px"
              viewBox="0 0 13 14"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="latest-deck"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="3-offer"
                  class="btn-svg"
                  transform="translate(-827.000000, -1427.000000)"
                  fill="#FFFFFF"
                >
                  <polygon
                    id="Path-2"
                    points="827 1427 827 1441.03125 839.1875 1434.03125"
                  />
                </g>
              </g>
            </svg>
            {{ button_text }}
          </a>
        </div>
      </div>
      <div
        class="bg-work"
        :class="page.acf.hero_picture_position"
        :style="{
          'background-image':
            'url( ' + page.better_featured_image.source_url + ' )',
        }"
      >
        <div class="hero-caption">
          <em>{{ hero_caption }}</em>
        </div>
      </div>
      <div class="mouse-icon-container">
        <a class="scroll-down-section" v-on:click="scrollToNextSection()">
          <div class="mouse-icon">
            <span class="mouse-wheel"></span>
          </div>
        </a>
      </div>
    </header>

    <div class="posts">
      <div class="row">
        <template v-for="(post, index) in posts">
          <!-- counting from 0, 1, 2... -->
          <!-- 1, 5, 9 slide  -->
          <div
            :key="index"
            v-if="index % 4 == 1 && index % 2 != 0"
            class="col-l-4 col-m-4 col-s-12"
          >
            <router-link
              tag="a"
              class="post"
              :to="'/' + slug + '/' + post.slug"
            >
              <p class="title" v-html="post.title.rendered"></p>
              <div
                class="bg"
                v-if="post.better_featured_image"
                :style="{
                  'background-image':
                    'url( ' + post.better_featured_image.source_url + ' )',
                }"
              />
            </router-link>
          </div>

          <!-- 2, 6, 10  slide -->
          <div
            :key="index"
            v-if="index % 4 == 2 && index % 2 == 0"
            class="col-l-4 col-m-4 col-s-12"
          >
            <router-link
              tag="a"
              class="post"
              :to="'/' + slug + '/' + post.slug"
            >
              <p class="title" v-html="post.title.rendered"></p>
              <div
                class="bg"
                v-if="post.better_featured_image"
                :style="{
                  'background-image':
                    'url( ' + post.better_featured_image.source_url + ' )',
                }"
              />
            </router-link>
          </div>

          <!-- 3, 7, 11 slide -->
          <div
            :key="index"
            v-if="index % 4 == 3 && index % 2 != 0"
            class="col-l-8 col-m-8 col-s-12"
          >
            <router-link
              tag="a"
              class="post"
              :to="'/' + slug + '/' + post.slug"
            >
              <p class="title" v-html="post.title.rendered"></p>
              <div
                class="bg"
                v-if="post.better_featured_image"
                :style="{
                  'background-image':
                    'url( ' + post.better_featured_image.source_url + ' )',
                }"
              />
            </router-link>
          </div>

          <!-- 4, 8, 12 slide -->
          <div
            :key="index"
            v-if="index % 4 == 0 && index % 2 == 0"
            class="col-l-8 col-m-8 col-s-12"
          >
            <router-link
              tag="a"
              class="post"
              :to="'/' + slug + '/' + post.slug"
            >
              <p class="title" v-html="post.title.rendered"></p>
              <div
                class="bg"
                v-if="post.better_featured_image"
                :style="{
                  'background-image':
                    'url( ' + post.better_featured_image.source_url + ' )',
                }"
              />
            </router-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../components/Modal.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";

export default {
  name: "work-page",
  props: ["slug"],
  data() {
    return {
      posts: null,
      pagecontent: null,
      count: 0,
      page: null,
      showModal: false,
      videosrc: null,
      button_text: null,
      hero_caption: null,
    };
  },
  components: {
    Modal,
    BlockCmgGreenhouse,
  },
  created: function () {
    this.$root.headeriswhite = true;
    this.$root.dataReady = false;
  },
  mounted: function () {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
        function (response) {
          self.pagecontent = response[0].content.rendered;
          self.setTitle(response[0].title.rendered);
          self.page = response[0];
          self.videosrc = response[0].acf.video_url;
          self.button_text = response[0].acf.button_text;
          self.hero_caption = response[0].acf.hero_caption;
        }
      )
        .done(function () {})
        .fail(function () {});
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/cases_studies?per_page=100",
        function (response) {
          self.posts = response;
          self.$root.dataReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setTitle: function (title) {
      title = title.normalize("NFD").replace("&#038;", "&");
      document.title = title + " - Weber Shandwick";
    },
    scrollToNextSection: function () {
      window.scrollTo({
        left: 0,
        top: $(window).height(),
        behavior: "smooth",
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Work.vue?8ed52f34